const CN = {
  Refreshing: "正在刷新",
  Refresh: "刷新",
  Thai: "泰语",
  English: "英语",
  Euro: "欧洲盘",
  Hongkong: "香港盘",
  Malay: "马来盘",
  "Sign Out": "登出",
  Change: "修改",
  to: "至",
  "Account Info": "账户信息",
  "Odds type": "盘口类型",
  Languages: "语言",
  Results: "赛果",
  Back: "返回",
  Draw: "和局",
  Refund: "退款",
  win: "赢",
  lose: "输",
  "half win": "赢一半",
  "half lose": "输一半",
  "half_win": "赢一半",
  "half_lose": "输一半",
  draw: "和局",
  refund: "退款",
  running: "进行中",
  waiting: "等待中",
  cancelled: "已取消",
  "All Announcement": "所有公告",
  "List of Sports": "体育项目列表",
  Football: "足球",
  Basketball: "篮球",
  "Coming Soon": "即将开赛",
  Cricket: "板球",
  Volleyball: "排球",
  Boxing: "拳击",
  "Thai boxing": "泰拳",
  Cockfight: "斗鸡",
  Bullfight: "斗牛",
  Combo: "混合过关",
  "Table Tennis": "乒乓球",
  Tennis: "网球",
  "All Result": "所有赛果",
  Rules: "规则",
  "Rules and regulations": "规则与条款",
  Statement: "账目流水",
  "Date time": "日期时间",
  Type: "类型",
  "Date & Time": "日期 & 时间",
  Time: "时间",
  Event: "赛事",
  "Full Time": "全场",
  "First Half": "上半场",
  "Live / Today": "滚球 / 今日",
  Live: "滚球",
  Today: "今日",
  Early: "早盘",
  ALL: "全部",
  Leagues: "联赛",
  League: "联赛",
  Search: "搜索",
  "Select / Cancel all": "全选 / 取消全部",
  selected: "已选择",
  "League is not found": "未找到相关联赛",
  Confirm: "确认",
  Cancel: "取消",
  "No market": "暂无盘口",
  "No competition": "暂无赛事",
  "No statement on this date range": "该日期范围内无账目记录",
  Competition: "赛事",
  "Half-time": "半场",
  "Second Half": "下半场",
  Q1: "第1节",
  Q2: "第2节",
  Q3: "第3节",
  Q4: "第4节",
  OT: "加时",
  "Match Result": "比赛结果",
  "Set 1": "第1局",
  "Set 2": "第2局",
  "Set 3": "第3局",
  "Set 4": "第4局",
  "Set 5": "第5局",
  "Total Points": "总得分",
  "Game 1": "第1局",
  "Game 2": "第2局",
  "Game 3": "第3局",
  "Total Games": "总局数",
  "Kickoff Time": "开赛时间",
  Match: "比赛",
  Final: "最终比分",
  "Total Sets": "总局数",
  "Full-time": "全场",
  Date: "日期",
  "No.": "编号",
  Message: "消息",
  "Bet amount": "下注金额",
  "Win / Lose": "输 / 赢",
  Commission: "返水",
  Total: "总计",
  "Place bet success": "投注成功",
  "Bet failed": "投注失败",
  "Bet Slip": "投注单",
  "My Bets": "我的投注",
  Parlay: "串关",
  Single: "单式投注",
  Matches: "赛事",
  "Max payout": "最高赔付",
  Max: "最大",
  Min: "最小",
  More: "更多",
  Bet: "投注",
  VALIDATION_ERROR: "验证错误",
  RATE_LIMIT_REQUEST: "请求过于频繁",
  CANNOT_GET_PROFILE: "无法获取个人资料",
  ODDS_CHANGED: "赔率已变更",
  MATCH_NOT_FOUND: "未找到相关赛事",
  OVER_LITMIT_PER_MATCH: "超过单场比赛投注限制",
  OVER_LITMIT_PER_BILL: "超过单笔注单投注限制",
  OVER_LITMIT_PER_DAY: "超过当日投注限制",
  ODDS_INVALID: "无效赔率",
  DUPLICATE_BET: "重复投注",
  INSUFFICIENT_BALANCE: "余额不足",
  LOCKED_ACCOUNT: "账户已锁定",
  SUSSPENDED_ACCOUNT: "账户已停用",
  UNAVAILABLE_BET: "目前无法投注",
  TICKET_REJECTED: "注单被拒绝",
  SYSTEM_ERROR: "系统错误，请稍后再试",
  INVALID_CURRENCY: "无效货币",
  INVALID_AMOUNT: "无效金额",
  SESSION_EXPIRED: "登录已过期",
  "Search Teams": "搜索球队或联赛...",
  Over: "大",
  Under: "小",
  "share kickoff": "开赛时间",
  "share link": "点击下方链接查看赔率",
  "share copied": "链接已复制到剪贴板",
  "share copy_failed": "复制链接失败",
  "Minimum parlay matches": "至少需要 {{count}} 场比赛",
  "Some matches unavailable": "部分比赛暂不可用",
};

export default CN;
